import { memo } from 'react';
import { Modal, ModalOverlay, ModalContent, Center, VStack, Text } from '@chakra-ui/react';

import IconButton from 'shared/IconButton';
import NextImage from 'shared/NextImage';

import { TYPES, icons, defaultSuccessModalData } from 'constants/StatusModal';

const StatusModal = ({
  type,
  isOpen,
  onClose,
  title = null,
  titleProps = null,
  description = null,
  descriptionProps = null,
  textContainerProps = null,
  ...props
}) => {
  const isError = type === TYPES.error;

  return (
    <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay w="100vw" h="100vh" bgColor="rgba(0,0,0,0.5)" />
      <ModalContent
        pos="relative"
        w="full"
        maxW={{
          desktop: '670px',
          laptop: '600px',
          tablet: 'clamp(400px, 80vw, 584px)',
          mobile: '343px',
        }}
        p={{ laptop: '48px', tablet: '40px', mobile: '24px' }}
        borderRadius={{ laptop: '48px', mobile: '24px' }}
        bgColor="white"
        {...props}
      >
        <VStack gap={isError ? '32px' : '24px'} textAlign="center">
          <Center
            bgColor={isError ? 'bg.gray' : 'bg.neonLight'}
            boxSize={{ laptop: '90px', mobile: '60px' }}
            borderRadius="50%"
          >
            <NextImage
              src={icons[type]}
              alt="Иконка статуса"
              w="auto"
              h="auto"
              boxSize={{ laptop: '36px', mobile: '24px' }}
            />
          </Center>

          <VStack gap={isError ? '20px' : '12px'} {...textContainerProps}>
            <Text
              as="h4"
              maxW={isError && { tablet: '300px', laptop: '400px', desktop: '430px' }}
              {...titleProps}
            >
              {title ?? defaultSuccessModalData.title[type]}
            </Text>
            <Text
              textStyle={isError ? 'h2' : 'h4'}
              fontSize={
                isError
                  ? { laptop: '18px', mobile: '12px' }
                  : { mobile: '12px', tablet: '16px', laptop: '20px', desktop: '24px' }
              }
              {...descriptionProps}
            >
              {description ?? defaultSuccessModalData.description[type]}
            </Text>
          </VStack>
        </VStack>

        <IconButton
          direction="cross"
          boxSize={{ mobile: '40px', laptop: '72px' }}
          pos="absolute"
          top={{ mobile: '8px', tablet: '0' }}
          right={{ mobile: '8px', tablet: '-56px', laptop: '-96px' }}
          ml="auto"
          bgColor="bg.white"
          border="none"
          iconProps={{
            w: 'auto',
            h: 'auto',
            boxSize: { mobile: '20px', laptop: '32px' },
          }}
          onClick={onClose}
        />
      </ModalContent>
    </Modal>
  );
};

export default memo(StatusModal);
